<div class="footer">
    <div class="footer__logo-agys max-width" [ngStyle]="{'background-color':commentcardStyles.FooterBackground, 'color': commentcardStyles.FooterTextColor}">
        <img src="assets/images/Reserve_Dark_Logo.png" alt="agys-logo" class="footer__img">
    </div>
</div>
